<template>
  <div
    :class="badgeList[activeIndex]?.light == 1 ? 'container1' : 'container2'"
  >
    <div class="main_con">
      <div class="top">
        <div class="top_left" @click="gaback">
          <img src="@/assets/newMedal/time/left1.svg" alt="" />
        </div>
        <div class="top_center">{{ cardItem.medalTypeName }}</div>
        <div class="topRight"></div>
      </div>
      <div class="swiper_con">
        <swiper class="scrollItem" :options="swiperOptions" style="width: 100%">
          <swiper-slide v-for="(item, index) in badgeList" :key="index">
            <div class="img_con">
              <img
                :src="imgUrl + (item.light == 1 ? item.iconId : item.fileId)"
                alt=""
              />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="title_con">
        <div class="title1" v-if="badgeList[activeIndex]?.light == 1">
          {{ badgeList[activeIndex]?.medalName }}
        </div>
        <div class="title1" v-else>未解锁</div>
        <div class="title2" v-if="badgeList[activeIndex]?.light == 1">
          雷士照明与你相伴<span style="color: #00ff94">{{
            badgeList[activeIndex]?.year[0]
          }}</span
          >时光
        </div>
        <!-- @click="handleDetailUnlock" -->
        <div class="title3" v-else>
          {{ badgeList[activeIndex]?.unlockDescribe }}
        </div>
      </div>
      <div class="badge_con">
        <div
          :class="`imgList${activeIndex}`"
          v-for="(item, index) in badgeList"
          :key="index"
        >
          <div :class="activeIndex == index ? 'imgOne' : ''">
            <img
              :class="`img${index}`"
              :src="imgUrl + (item.light == 1 ? item.iconId : item.fileId)"
              alt=""
            />
            <div class="name" v-if="activeIndex == index">
              {{ item?.medalName }}
            </div>
          </div>
        </div>
      </div>
      <div class="timeTitle" v-if="badgeList[activeIndex]?.getTime">
        于{{ badgeList[activeIndex]?.getTime }}点亮勋章
      </div>
      <div class="check_con">
        <el-button @click="toDetail(badgeList[activeIndex])"
          >查看详情</el-button
        >
      </div>
      <div class="logo">
        <!-- <img src="../../../../assets/newMedal/time/logo.svg" alt="" /> -->
      </div>
    </div>
    <van-dialog
      class="dialog"
      v-model="showUnlock"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog-people">解锁说明：</div>
      <div class="dialog-reason">
        <div>
          <van-field
            v-model="unlockExplain"
            rows="3"
            autosize
            type="textarea"
            readonly
            show-word-limit
          />
        </div>
      </div>
      <div class="dialog-btn">
        <el-button @click="cancelBtn">取消</el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import api from "@/apis/medal";
import moment from "moment";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    let _this = this;
    return {
      activeIndex: 0,
      swiperOptions: {
        loop: true,
        // autoplay: false,
        loopedSlides: 0,
        loopAdditionalSlides: 0,
        slidesPerView: "auto",
        effect: "coverflow",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -10,
          depth: 290,
          modifier: 1,
          slideShadows: false
        },
        on: {
          init: function () {
            _this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
            _this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
            const nameIndex = _this.cardItem.medals.findIndex(
              item => item?.medalName == _this.badgeItem?.medalName
            );
            _this.activeIndex = this.realIndex;
            this.activeIndex = nameIndex;
            _this.activeIndex = nameIndex;
          },
          slideChange: function () {
            _this.activeIndex = this.realIndex;
          }
        }
      },
      badgeList: [],
      imgUrl: "",
      cardItem: {},
      badgeItem: {},
      titleList: [],
      showUnlock: false,
      unlockExplain: ""
    };
  },
  created() {
    this.imgUrl = api.imgUrl;
    this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
    this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
  },
  mounted() {
    //获取徽章列表
    this.badgeList = this.cardItem.medals.map(item => {
      item.year = item.medalName?.match(/\d+/);
      item.getTime = item.getTime
        ? moment(item.getTime).format("YYYY/MM/DD")
        : "";
      return item;
    });
    //排序徽章列表
    this.badgeList = this.badgeList.sort((a, b) => a.companyAge - b.companyAge);
  },
  methods: {
    changeSlid() {},
    changeSlid1() {},
    //返回
    gaback() {
      localStorage.setItem("tabValue", JSON.stringify(this.cardItem.id));
      this.$router.back();
    },
    //跳转徽章详情
    toDetail(info) {
      if (info?.light == 1) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: info?.recordId
          }
        });
      } else {
        return this.$message({
          type: "warning", // success error warning
          message: "您还未获取该周年卡！",
          duration: 2000
        });
      }
    },
    //解锁说明
    handleDetailUnlock() {
      this.unlockExplain = this.badgeList[this.activeIndex].unlockDescribe;
      this.showUnlock = true;
    },
    //取消
    cancelBtn() {
      this.showUnlock = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container1 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/time/time1.png");
  background-size: 100% 100%;
  position: relative;
}
.container2 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/time/time2.png");
  background-size: 100% 100%;
  position: relative;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 30px;
  color: #00ff94;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top_center {
    margin-left: -15%;
  }
}
.swiper_con {
  position: absolute;
  top: 6vh;
  width: 100%;
  // margin-top: 7vh;
  .scrollItem {
    width: 100% !important;
    height: 540px;
  }
  .swiper-slide {
    width: 540px;
    display: flex;
    justify-content: center;
  }
  .swiper-slide-active {
    .img_con {
      opacity: 1 !important;
    }
  }
  .img_con {
    width: 540px;
    height: 540px;
    opacity: 0.38;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.title_con {
  width: 100%;
  position: absolute;
  top: 47.7vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title1 {
    color: #00ff94;
    font-size: 34px;
  }
  .title4 {
    color: #fff;
    font-size: 34px;
  }
  .title2 {
    font-size: 28px;
    color: #ffffff;
  }
  .title3 {
    width: 50%;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
  }
}
.badge_con {
  width: 100%;
  position: absolute;
  top: 60vh;
  display: flex;
  justify-content: center;
  .imgList0 {
    .imgOne {
      background: #fff;
      border-radius: 50%;
      width: 90px;
      height: 90px;
      border: 10px solid #000;
      box-shadow: 0 0 20px rgba(0, 255, 148, 1); /* 添加外阴影 */
      position: absolute;
      left: 50%;
      top: 60.3%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .img0 {
      width: 90px;
      height: 90px;
    }
    .name {
      width: 100px;
      position: absolute;
      bottom: -50px;
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
    .img1 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 58%;
      top: 60%;
    }
    .img2 {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 70%;
      top: 62%;
    }
    .img3 {
      width: 70px;
      height: 70px;
      position: absolute;
      left: 81%;
      top: 59%;
    }
    .img4 {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 90%;
      top: 59%;
    }
  }
  .imgList1 {
    .imgOne {
      background: #fff;
      border-radius: 50%;
      width: 90px;
      height: 90px;
      border: 10px solid #000;
      box-shadow: 0 0 20px rgba(0, 255, 148, 1); /* 添加外阴影 */
      position: absolute;
      left: 50%;
      top: 60.3%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .img0 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 31%;
      top: 60%;
    }
    .name {
      width: 100px;
      position: absolute;
      bottom: -50px;
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
    .img1 {
      width: 90px;
      height: 90px;
    }
    .img2 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 58%;
      top: 62%;
    }
    .img3 {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 70%;
      top: 62%;
    }
    .img4 {
      width: 70px;
      height: 70px;
      position: absolute;
      left: 81%;
      top: 59%;
    }
  }
  .imgList2 {
    .imgOne {
      background: #fff;
      border-radius: 50%;
      width: 90px;
      height: 90px;
      border: 10px solid #000;
      box-shadow: 0 0 20px rgba(0, 255, 148, 1); /* 添加外阴影 */
      position: absolute;
      left: 50%;
      top: 60.3%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .name {
      width: 100px;
      position: absolute;
      bottom: -50px;
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
    .img0 {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 19%;
      top: 60%;
    }
    .img1 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 31%;
      top: 60%;
    }

    .img2 {
      width: 90px;
      height: 90px;
    }
    .img3 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 58%;
      top: 62%;
    }
    .img4 {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 70%;
      top: 62%;
    }
  }
  .imgList3 {
    .imgOne {
      background: #fff;
      border-radius: 50%;
      width: 90px;
      height: 90px;
      border: 10px solid #000;
      box-shadow: 0 0 20px rgba(0, 255, 148, 1); /* 添加外阴影 */
      position: absolute;
      left: 50%;
      top: 60.3%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .name {
      width: 100px;
      position: absolute;
      bottom: -50px;
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
    .img0 {
      width: 70px;
      height: 70px;
      position: absolute;
      left: 8%;
      top: 60%;
    }
    .img1 {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 19%;
      top: 60%;
    }
    .img2 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 31%;
      top: 60%;
    }

    .img3 {
      width: 90px;
      height: 90px;
    }
    .img4 {
      width: 85px;
      height: 85px;
      position: absolute;
      left: 58%;
      top: 62%;
    }
  }
  .imgList4 {
    .imgOne {
      background: #fff;
      border-radius: 50%;
      width: 90px;
      height: 90px;
      border: 10px solid #000;
      box-shadow: 0 0 20px rgba(0, 255, 148, 1); /* 添加外阴影 */
      position: absolute;
      left: 50%;
      top: 60.3%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .name {
      width: 100px;
      position: absolute;
      bottom: -50px;
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
    .img0 {
      width: 65px;
      height: 65px;
      position: absolute;
      left: 2%;
      top: 60%;
    }
    .img1 {
      width: 70px;
      height: 70px;
      position: absolute;
      left: 11%;
      top: 60%;
    }
    .img2 {
      width: 75px;
      height: 75px;
      position: absolute;
      left: 21%;
      top: 60%;
    }
    .img3 {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 32%;
      top: 62%;
    }

    .img4 {
      width: 90px;
      height: 90px;
    }
  }
}
.timeTitle {
  width: 100%;
  position: absolute;
  top: 78vh;
  display: flex;
  justify-content: center;
  color: #ffffff;
  font-size: 22px;
}
.check_con {
  width: 100%;
  position: absolute;
  bottom: 9vh;
  display: flex;
  justify-content: center;
  ::v-deep {
    .el-button {
      width: 400px;
      height: 80px;
      color: #fff;
      background: #008755;
      font-size: 36px;
      border-radius: 40px;
      border-color: #008755;
    }
  }
}
.logo {
  position: absolute;
  bottom: 3vh;
  left: 50%;
  transform: translateX(-50%);
}
.dialog {
  height: 190px * $zoom;
  padding: 30px;

  .dialog-people {
    margin-bottom: 30px;
  }

  .dialog-reason {
    ::v-deep {
      .van-cell {
        background: rgba(244, 244, 244, 1);
        margin-top: 30px;
        height: 280px;
      }

      .van-field__control {
        height: 200px !important;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
    width: 100%;

    button {
      width: 50%;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
    }
  }
}
</style>
